<template>
    <Loading v-bind:show="showLoading">
        <PageTitle title="Fies - Analítico" />
        <div v-if="!showLoading && $featureToggle && $featureToggle.INTEGRA_FIES_BASEANALITICAFIES">
            <div class="md-layout-item md-size-100" v-if="dadosAba">
                <Grid v-bind:Data="dadosAba.baseAnaliticaFies"
                      v-bind:Header="header"
                      Name="BaseAnaliticaFies"
                      Title="Total"
                      OrderBy="dataSituacao"
                      v-bind:HeaderDetalhes="null"
                      v-bind:DetalhesCombo1="dadosAba.periodo"
                      v-bind:DetalhesCombo2="dadosAba.situacaoFies"
                      v-bind:DetalhesCombo3="null" />
            </div>
        </div>
    </Loading>
</template>
<script>
    import Grid from '@/components/Grid';
    import Fies from '@/services/FiesService.js';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';

    export default {
        components: {
            Grid,
            Loading,
            PageTitle
        },
        created() {
            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {
                let a = JSON.parse(sessionStorage.Aluno);
                //Coloca o perfil de aluno disponível na variável aluno
                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                    //Verifica se os dados da Aba ja esta carregado
                    if (a.Fies) {
                        this.dadosAba = a.Fies;
                    }
                }
                else
                    this.$router.push('home');
            }

            this.fiesService = new Fies(this);

            if (this.$featureToggle.INTEGRA_FIES_BASEANALITICAFIES) {
                //Verifica se a aba não está carregada
                if (!this.dadosAba) {
                    //Popula os dados da aba
                    this.showLoading = true;
                    this.fiesService.BaseAnaliticaFies({
                        Cpf: this.aluno.cpf
                    }).then(
                        data => {
                            if (data.ok) {
                                this.dadosAba = data.dados;
                            }
                            else {
                                this.$modal.info(data.Mensagem);
                            }
                        },
                        error => {
                            if (error.status != 500)
                                this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                            else
                                this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        }).finally(() => {
                            this.showLoading = false;
                        });
                }
            }
            else {
                this.$modal.alert(this.$msgFeatureToggle);
            }
        },
        beforeDestroy() {
            let aluno = JSON.parse(sessionStorage.Aluno);

            //Armazena os dados da aba pra nao precisar carregar novamente
            aluno.Fies = this.dadosAba;
            sessionStorage.setItem("Aluno", JSON.stringify(aluno));
        },
        data() {
            return {
                aluno: null,
                showLoading: false,
                header: [
                    {
                        Titulo: "Semestre",
                        Field: "semestre",
                        Width: "100px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Situação FIES",
                        Field: "situacaoSisFies",
                        Width: "100px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Data Situação FIES",
                        Field: "dataSituacaoFies",
                        Width: "80px",
                        Tipo: "date"
                    },
                    {
                        Titulo: "Fluxo FIES",
                        Field: "fluxoFies",
                        Width: "50px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Valor Financiamento",
                        Field: "valorFinanciamento",
                        Width: "100px",
                        Tipo: "moeda"
                    },
                    {
                        Titulo: "Valor Mensal Aditado",
                        Field: "valorMensalAditado",
                        Width: "100px",
                        Tipo: "moeda"
                    },
                    {
                        Titulo: "% DRM",
                        Field: "percentualDrm",
                        Width: "100px",
                        Tipo: "moeda"
                    }
                ],

                dadosAba: null
            }
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-field {
        max-width: 100%;
        font-weight: bold;
    }
</style>
